import React, { createContext, useContext, useState, useEffect } from 'react';
import http from "../Api/http";
import { useNavigate } from "react-router-dom";
import { t } from 'i18next';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false); // يتم استخدامه داخل المزود فقط
  const [error, setError] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);


  useEffect(() => {
    const storedUser = localStorage.getItem("traffic_user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (err) {
      }
    }
    setLoadingUser(false);
  }, []);

  const login = async (username, password, i18n) => {
    setLoading(true);
    setError(null);
    try {
      const result = await http.postJsonAxios(http.actions.Auth.urlLogin, { username, password },t);

      if (result.status === 200) {
        const data = result.data;
        if (data.Success) {
          setUser(data.User);
          localStorage.setItem("traffic_user", JSON.stringify(data.User));
          return { success: true };
        } else {
          return { success: false, message: data.message };
        }
      } else {
        return { success: false, message: "خطأ في الاتصال بالخادم" };
      }
    } catch (error) {
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("traffic_user");
    localStorage.removeItem("traffic_token");
    navigate("/"); 
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, error,loadingUser  }}>
      {children}
    </AuthContext.Provider>
  );
};
